import React from 'react';
import HealthFrontDeskList from './components/HealthFrontDeskList';

const HealthFrontDesk = () => <HealthFrontDeskList />;

export default HealthFrontDesk;
